export const INITIALIZE = 'INITIALIZE';

export const LOAD_MESSAGES = 'LOAD_MESSAGES';
export const LOAD_MESSAGES_SUCCESS = `${LOAD_MESSAGES}_SUCCESS`;
export const LOAD_MESSAGES_FAIL = `${LOAD_MESSAGES}_FAIL`;

export const LOAD_EVENT = 'LOAD_EVENT';
export const LOAD_EVENT_SUCCESS = `${LOAD_EVENT}_SUCCESS`;
export const LOAD_EVENT_FAIL = `${LOAD_EVENT}_FAIL`;

export const LOAD_AUDITS = 'LOAD_AUDITS';
export const LOAD_AUDITS_SUCCESS = `${LOAD_AUDITS}_SUCCESS`;
export const LOAD_AUDITS_FAIL = `${LOAD_AUDITS}_FAIL`;

export const EVENT_TIMELINE_PROPS = 'EVENT_TIMELINE_PROPS';

export const loadTranslationServiceMessages = locale => dispatch => {
  dispatch({ type: LOAD_MESSAGES });

  const localeToLoad = ['en', 'fr'].includes(locale) ? locale : 'en';

  import(`../../translations/${localeToLoad}.json`)
    .then(response =>
      dispatch({
        type: LOAD_MESSAGES_SUCCESS,
        payload: response,
      }),
    )
    .catch(() => {
      dispatch({
        type: LOAD_MESSAGES_FAIL,
        error: new Error('Loading Translation Messages Failed'),
      });
    });
};

export function loadEventData(eventId) {
  return {
    type: LOAD_EVENT,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/events/${eventId}`,
      method: 'get',
    },
  };
}

export function loadEventAudits(eventId) {
  return {
    type: LOAD_AUDITS,
    meta: {
      xmApi: true,
      method: 'getall',
      uri: '/webapi/xm/1/audits',
      params: {
        eventId,
        auditType:
          'NOTIFICATION_DELIVERED,NOTIFICATION_FAILED,RESPONSE_RECEIVED,EVENT_ANNOTATED',
        limit: 1000,
      },
    },
  };
}

export const initializeTimelineState = () => dispatch => {
  dispatch({ type: INITIALIZE });
};
